import { SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface ISituation {
    label: string;
    sx?: SxProps<Theme>;
}

const Situation: React.FC<ISituation> = ({ label, sx }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Typography
            sx={{
                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                fontSize: 10,
                color: theme[themeStyle].primary_orange,
                backgroundColor: 'rgba(255, 165, 0, 0.1)',
                padding: '2px 6px',
                borderRadius: '4px',
                textTransform: 'uppercase',
                ...sx,
            }}>
            {label}
        </Typography>
    );
};

export { Situation };
